import { createSelector } from "reselect";
import { RootStore } from "store/reducer";

const selectState = (state: RootStore) => state.accounts;

export const selectAuthSession = createSelector(selectState, (state) => state.session);
